import { useSearchParams } from "react-router-dom";

export const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryObject = Object.fromEntries(searchParams.entries());

  return {
    query: queryObject,
    setQuery: setSearchParams,
  };
};
